import { type ReactNode } from 'react'
import { Dropdown, DropdownItem, DropdownTitle } from '@/components/Dropdown'
import { Icon } from '@/components/Icon'
import styles from './FirmDashboardTableControls.module.css'

export interface FirmDashboardTableControlsProps {
  onExportCsv: () => void
  button: ReactNode
}

export function FirmDashboardTableControls({
  onExportCsv,
  button,
}: FirmDashboardTableControlsProps) {
  return (
    <Dropdown autoDismiss position="bottom-end" button={button}>
      <div className={styles.tableControlsContainer}>
        <DropdownTitle>Menu</DropdownTitle>
        <FirmDashboardTableControlsItem
          icon={
            <Icon
              className={styles.tableControlsItemIcon}
              name="download"
              size={24}
            />
          }
          onPress={onExportCsv}
          testId="job-management-table-menu-export-csv"
        >
          Export CSV
        </FirmDashboardTableControlsItem>
      </div>
    </Dropdown>
  )
}

interface FirmDashboardTableControlsItemProps {
  children: ReactNode
  icon: ReactNode
  onPress?: () => void
  testId?: string
}

function FirmDashboardTableControlsItem({
  children,
  icon,
  onPress,
  testId,
}: FirmDashboardTableControlsItemProps) {
  return (
    <DropdownItem icon={icon} onPress={onPress} buttonTestId={testId}>
      {children}
    </DropdownItem>
  )
}
